import r from "./ghl-ui.es1235.js";
var t = function() {
  try {
    var e = r(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const i = t;
export {
  i as default
};
